import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleOutline } from '@/components/Icons/CheckCircleOutline';
import { SubtractCircle } from '@/components/Icons/SubtractCircle';
import { tv } from '@/utils/tv';

interface Props {
  isCanceled: boolean;
  hideOnMobile?: boolean;
}

const chip = tv({
  base: 'text-caption-12 h-[22px] items-center gap-1 shrink-0 rounded-xl px-2 py-[2px]',
  variants: {
    isCanceled: {
      true: 'bg-destructive-surface text-destructive',
      false: 'bg-success-surface text-successful dark:text-success',
    },
    hideOnMobile: {
      true: 'hidden md:inline-flex',
      false: 'inline-flex',
    },
  },
});

export const AbsenceStatusChip: React.FC<Props> = ({
  isCanceled,
  hideOnMobile = false,
}) => {
  const { t } = useTranslation();

  return (
    <span className={chip({ isCanceled, hideOnMobile })}>
      {isCanceled && <SubtractCircle className="size-4 shrink-0" />}
      {!isCanceled && (
        <CheckCircleOutline className="size-4 shrink-0 text-successful dark:text-success" />
      )}
      {isCanceled && (
        <span>{t('absenceApplication.detail.statusCanceled')}</span>
      )}
      {!isCanceled && (
        <span>{t('absenceApplication.detail.statusAccepted')}</span>
      )}
    </span>
  );
};
